<template>
  <h1>Ooops...Something went wrong!</h1>
  <div>
    <router-link to="/">To the homepage</router-link>
  </div>
</template>

<script>

</script>


<style scoped>

</style>